module.exports = __webpack_public_path__ + "static/media/wanshengjie_headkv.91c289f5.png";